/**
 * @module navigation
 */
(function StickyNavigation () {

    function stickyNavigation () {
        /**
         * // local object availability
         * @type {stickyNavigation}
         * @private
         */
        var _this = this;

        /**
         * @method cacheDom
         *
         *  assign {jQuery|HTMLElement(s)} to {stickyNavigation} object
         */
        this.cacheDom = function () {
            this.$bodyElement = $('body');
            this.$headerElement = $("[data-html-element='header']");
            this.$window = $(window);
        };

        /**
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            _this.$window.on('load', function (){
                _this.render();
            });
            _this.$window.resize(function (){
                _this.render();
            });
        };

        /**
         * @method setNavigationHeight
         * @returns {undefined}
         */
        this.setNavigationHeight = function () {
            _this.navHeight = _this.$headerElement[0].offsetHeight;
        };

        /**
         * @method checkIfSticky
         * @returns {undefined}
         */
        this.checkIfSticky = function (){
            _this.isStickyNavigation = _this.$headerElement.data().hasOwnProperty('stickyNavigation');
            return true;
        };

        /**
         * @method bodyClassHandling
         * @returns {undefined}
         */
        this.bodyClassHandling = function (){
            if(_this.checkIfSticky) {
                $('body').addClass('sticky-navigation');
            } else {
                $("body").removeClass("sticky-navigation");
            }
        };

        /**
         * @method observer
         * @returns {undefined}
         */
        this.observer = function () {
            _this.bodyClassHandling();
            _this.setNavigationHeight();
        };

        /**
         * @method render
         * @returns {undefined}
         */
        this.render = function (){
            _this.observer();
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom();
            _this.observer();
            _this.bindEvents();
        };

        /**
         * initialize call
         */
        _this.init();

    }


    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }


    window.Juzo.stickyNavigation = stickyNavigation;
}) ();


$ (document).ready (function () {
    if ($("[data-sticky-navigation='is-sticky']").length) {
        window.Juzo.stickyNavigation.call(window.Juzo.stickyNavigation);
    }
});

// call the funciton when Neos Backend is reloaded
document.addEventListener('Neos.PageLoaded', function(event) {
    var isBackend = window.Juzo.Context.isBackend();
    if (isBackend && $("[data-sticky-navigation='is-sticky']").length) {
        window.Juzo.stickyNavigation.call(window.Juzo.stickyNavigation);
    } else if (isBackend) {
        $("body").removeClass("sticky-navigation");
    }
}, false);